<template>
  <div
    v-if="!option.children.length"
    :id="option.id"
    class="paddingCollapse"
  >
    <a
      tabindex="0"
      :aria-label="option.i18n[locale] || option.naturalKey"
      @click="select(option, option.i18n[locale] || option.naturalKey, option.id)"
      @keyup.enter="select(option, option.i18n[locale] || option.naturalKey, option.id)"
      @keyup.space="select(option, option.i18n[locale] || option.naturalKey, option.id)"
    >
      {{ option.i18n[locale] || option.naturalKey }}</a>
  </div>
  <b-collapse
    v-else
    :model-value="isOpen"
    animation="slide"
    class="collapseCardOneSelect"
  >
    <template #trigger="props">
      <div
        :aria-expanded="props.open"
        class="card-header"
      >
        <p
          class="card-header-title"
          :aria-label="option.i18n[locale] || option.naturalKey"
        >
          {{ option.i18n[locale] || option.naturalKey }}
        </p>
        <a
          class="card-header-icon"
          tabindex="0"
          @keyup.enter="isOpen = !isOpen"
          @keyup.space="isOpen = !isOpen"
        >
          <b-icon :icon="props.open ? 'chevron-up' : 'chevron-down'" />
        </a>
      </div>
    </template>
    <div class="card-content">
      <div class="content">
        <CollapseMenuOneSelect
          v-for="child in option.children"
          :key="child.id"
          :id-reference-scope="idReferenceScope"
          :index="localeIndex"
          :is-child="true"
          :option="child"
          @select-menu-item="select"
        />
      </div>
    </div>
  </b-collapse>
</template>

<script lang="ts">
import { ref, computed, onMounted } from "vue";
import services from "@/composable/services";
import "@/style/components/CollapseMenuSelect.scss";
import { BCollapse } from "buefy";

export default {
  name: "CollapseMenuOneSelect",
  components: { BCollapse },
  props: {
    option: {
      type: Object,
      required: true,
    },
    listSelect: Array,
    idReferenceScope: String,
    isChild: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  emits: ["select-menu-item", "change-style-if-selected"],
  setup(props, { emit }) {
    const isOpen = ref(false);
    const locale = services.internationalisationService.getLocale();
    const displayText = computed(() => props.option.i18n[locale] || props.option.naturalKey);
    const localeIndex = computed(() => props.index || 0);

    onMounted(() => {
      if (props.isChild) {
        localeIndex.value = props.index + 1;
      }
    });

    function changeStyleIfSelected(localID) {
      const localElement = document.getElementById(localID);
      if (localElement) {
        Array.from(document.querySelectorAll("div.colorSelected"))
          .filter(
            el =>
              el.id && el.id.includes(props.idReferenceScope + "K") && !el.id.includes(localID),
          )
          .forEach((element) => {
            element.classList.remove("colorSelected");
          });
        localElement.classList.add("colorSelected");
      }
    }

    function select(option, localName, localID) {
      changeStyleIfSelected(localID);
      option.localName = option.localName || localName;
      emit("select-menu-item", option || { ...this.option, localName });
    }

    return {
      select,
      isOpen,
      locale,
      displayText,
      localeIndex,
    };
  },
};
</script>

<style lang="scss" scoped>

.colorSelected {
  background-color: rgba(0, 100, 100, 0.4);
}
</style>
